<template>
  <div class="flex flex-column gap-3">
    <h3 class="m-0">Bookmarks</h3>

    <bookmarks-table />
  </div>
</template>

<script>
import LayoutBookmark from '@/components/layout/layout-bookmark.vue'

export default {
  components: {
    'bookmarks-table': LayoutBookmark
  }
}
</script>
